import React, { useState } from "react";
import { Box, Button, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { BADGE_COLORS } from "../../../../components/ui/badgeColors";
import { useAlmacenes } from "../../hooks/useAlmacenes";

/**
 * Nave en la que se cuenta UN artículo, en una línea compacta: normalmente es la
 * general de la pantalla y aquí solo se cambia como excepción para este artículo
 */
const SelectorNaveArticulo = ({ value, almacenGeneral, opciones, stockPorAlmacen, conteos, onChange, disabled }) => {
    const [ancla, setAncla] = useState(null);
    const { getNombreAlmacen } = useAlmacenes();
    const esExcepcion = Boolean(value && almacenGeneral && value !== almacenGeneral);

    const elegir = (codigo) => {
        setAncla(null);
        if (codigo !== value) onChange(codigo);
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}>
            <Typography sx={{ fontSize: 13, color: "#495057" }}>{value ? "Contando en:" : "Sin nave:"}</Typography>
            <Button
                size="small"
                onClick={(evento) => setAncla(evento.currentTarget)}
                disabled={disabled}
                endIcon={<ArrowDropDownIcon />}
                aria-label={value ? `Cambiar nave de este artículo (${getNombreAlmacen(value)})` : "Elegir nave de este artículo"}
                sx={{
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: 13,
                    color: "#212529",
                    px: 1,
                    minWidth: 0,
                    "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
                }}
            >
                {value ? getNombreAlmacen(value) : "elegir"}
            </Button>
            {esExcepcion && (
                <Typography sx={{ fontSize: 12, fontWeight: 600, color: BADGE_COLORS.AMBER.text }}>· solo este artículo</Typography>
            )}
            {!value && (
                <Typography sx={{ fontSize: 12, color: "#6c757d" }}>o elige arriba dónde estás contando</Typography>
            )}

            <Menu anchorEl={ancla} open={Boolean(ancla)} onClose={() => setAncla(null)}>
                {esExcepcion && (
                    <MenuItem onClick={() => elegir(almacenGeneral)} sx={{ fontWeight: 600 }}>
                        Volver a {getNombreAlmacen(almacenGeneral)} (general)
                    </MenuItem>
                )}
                {opciones.map((codigo) => {
                    const contado = conteos.find((conteo) => conteo.almacen === codigo);
                    const detalle = [
                        stockPorAlmacen ? `stock ${stockPorAlmacen[codigo] ?? 0}` : null,
                        contado ? `contado ${contado.cantidadContada}` : null,
                    ].filter(Boolean);
                    return (
                        <MenuItem key={codigo} selected={codigo === value} onClick={() => elegir(codigo)}>
                            <ListItemText
                                primary={getNombreAlmacen(codigo)}
                                secondary={detalle.join(" · ") || null}
                                primaryTypographyProps={{ fontSize: 14 }}
                                secondaryTypographyProps={{ fontSize: 12 }}
                            />
                        </MenuItem>
                    );
                })}
            </Menu>
        </Box>
    );
};

export default SelectorNaveArticulo;
